import { render } from "./FrequencyCell.vue?vue&type=template&id=7fdb46e6"
import script from "./FrequencyCell.vue?vue&type=script&lang=js"
export * from "./FrequencyCell.vue?vue&type=script&lang=js"

import "./FrequencyCell.vue?vue&type=style&index=0&id=7fdb46e6&lang=css"

import exportComponent from "/container/application/releases/20260729235012/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__